export const localStorageCleanup = () => {
    localStorage.removeItem('fpqCurrentChildren');
    localStorage.removeItem('fpqDesiredChildren');
    localStorage.removeItem('dateOfBirth');
    localStorage.removeItem('firstMenstruationYear');
    localStorage.removeItem('sexualDebutYear');
    localStorage.removeItem('childbearingYearFrame');
    localStorage.removeItem('menopauseYear');
    localStorage.removeItem('pregnancies');
    localStorage.removeItem('adoptions');
    localStorage.removeItem('stepchildren');
    localStorage.removeItem('childrenDeath');
    localStorage.removeItem('sexualPreference');
    localStorage.removeItem('relationshipStatus');
    localStorage.removeItem('contraceptiveMethods');
    localStorage.removeItem('fertilityPreservationMethods');
    localStorage.removeItem('fertilityTreatments');
    localStorage.removeItem('cancerDiagnosis');
    localStorage.removeItem('cancerTreatments');
    localStorage.removeItem('isFirstTimeLogin');

};

export const arrayOfNumbers = (start, length) => {
    return Array.from({ length: length }, (v, k) => k + start);
};

export const arrayOfPeriodAges = (currentAge, isEligibleAge) => {
    if (isEligibleAge) {
        return arrayOfNumbers(8, currentAge - 7);
    }
    else {
        return arrayOfNumbers(0, 0);
    }
}